import React from 'react'
import { useParams } from 'react-router-dom'
import { useSIPContext } from '../../../state-management/contexts/SIPContext'
import { OTPVerficationPage } from '../../OTP/OTPVerficationPage'
import { useUserDetails } from '../../../hooks/useUserDetails'

export const SIPOTPPage: React.FC = () => {
  const { isin: isinParam } = useParams<{ isin: string }>()
  const pathIsin = isinParam ?? ''
  const { otpVerificationState, otpVerificationHandlers } = useSIPContext()
  const { userDetails } = useUserDetails()

  return (
    <OTPVerficationPage
      numberOfDigits={6}
      phoneNumber={userDetails?.mobileNumber || ''}
      emailId={userDetails?.emailId || ''}
      isOTPVerified={otpVerificationState.isOTPVerified}
      OTPVerificationFailedCase={otpVerificationState.OTPVerificationFailedCase}
      isOTPVerificationLoading={otpVerificationState.isOTPVerificationLoading}
      isOTPVerificationLimitExceeded={otpVerificationState.isOTPVerificationLimitExceeded}
      handleResendOTP={otpVerificationHandlers.handleResendOTP}
      handleOTPVerification={otpVerificationHandlers.handleOTPVerification}
      inputContainerTestLocator='MFE_ENTER_OTP'
      trackingFund={pathIsin ? { fundIsin: pathIsin } : undefined}
    />
  )
}
